// extracted by mini-css-extract-plugin
export default {"main":"Main_main__F2ek1","main__block":"Main_main__block__x4QMM"};